import { CognitoUser } from '../services/cognitoService';

/** Only these users see "Enviar Email" in Gestão de Clientes / Workboard (match by profile name or login username). */
export const CLIENT_MANAGEMENT_EMAIL_SENDER_NAMES = [
  'Beatriz Matos',
  'Álvaro Batista',
  'Iago Sousa',
] as const;

function normalizePersonNameKey(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
}

export function userMayUseClientManagementEmailButton(u: CognitoUser | null): boolean {
  if (!u) return false;
  const allowed = new Set(CLIENT_MANAGEMENT_EMAIL_SENDER_NAMES.map(normalizePersonNameKey));
  const fullFromProfile = [u.given_name, u.family_name].filter(Boolean).join(' ').trim();
  if (fullFromProfile && allowed.has(normalizePersonNameKey(fullFromProfile))) return true;
  const login = (u.username || '').split('@')[0].replace(/[._-]+/g, ' ').trim();
  if (login && allowed.has(normalizePersonNameKey(login))) return true;
  return false;
}
